import { render, staticRenderFns } from "./trip_modal.vue?vue&type=template&id=63e57a8a&scoped=true&"
import script from "./trip_modal.vue?vue&type=script&lang=js&"
export * from "./trip_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e57a8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63e57a8a')) {
      api.createRecord('63e57a8a', component.options)
    } else {
      api.reload('63e57a8a', component.options)
    }
    module.hot.accept("./trip_modal.vue?vue&type=template&id=63e57a8a&scoped=true&", function () {
      api.rerender('63e57a8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/calendar/trip/trip_modal.vue"
export default component.exports